<template>
  <div v-if="user" class="friends-page">
    <div class="friends-heading">Friend Accounts Disabled</div>
      <div class="friends-intro">
        To ensure that all authors can find a book to review, Friend Accounts have been disabled for the foreseeable future.
        <div class="friends-how-item">Any assignments your Friends currently have can still be completed, and you will both receive snaps upon review verification. 
        Friends will not be able to take new assignments while this feature is disabled.
        </div>
      </div>

    <!-- <div class="friends-heading">Invite Friends to Read</div>
    <div class="friends-intro">
      As a member, you can invite up to 4 friends to read for free on Pubby.
      When they review books, you'll earn the snaps that you would have earned
      if you had read the book.
    </div>

    <div class="friends-img-container">
      <img class="friends-img" src="/images/friends.jpg" />
    </div>

    <div class="friends-subheading">How It Works</div>
    <div class="friends-how-item">
      1. You send your invite URL to your friends. (Email, text, social media
      message, etc.)
    </div>
    <div class="friends-how-item">
      2. Your friends sign up for free and pick books to read on their own. They
      leave reviews using their personal Amazon account.
    </div>
    <div class="friends-how-item">
      3. When each review has been posted on Amazon and seen by our staff,
      you earn the snaps that you would have earned if you had read the book.
    </div>

    <div class="friends-subheading">Your Invite URL</div>
    <div class="refer-link">
      <div class="refer-url-container">
        <div class="refer-label">Your Link To Share</div>
        <input
          type="text"
          readonly
          class="refer-url"
          :value="shareLink"
          onClick="this.select();"
        />
      </div>
      <div class="refer-copy-icon" @click="copyLink">
        <i class="material-icons">link</i>
      </div>
      <div class="refer-copy-tool" @click="copyLink">Copy</div>
    </div> -->

    <div class="friends-subheading">Your Friends</div>
    <div v-if="!friendsTable" class="friends-intro">
      You don't have any friends that have signed up yet. When you do, you'll be
      able to see their reading activity here.
    </div>
    <div v-else class="friends-table">
      <div class="friends-row">
        <div class="friends-hcell friends-cell-name">Name</div>
        <div class="friends-hcell">Currently Reading</div>
        <div class="friends-hcell">Completed Reviews</div>
        <div class="clearfix"></div>
      </div>
      <div class="friends-row" v-for="row in friendsTable" :key="row.name">
        <div class="friends-cell friends-cell-name">{{ row.name }}</div>
        <div class="friends-cell">{{ row.inProgressReviews }}</div>
        <div class="friends-cell">{{ row.completedReviews }}</div>
        <div class="friends-cell-remove"><button class="action" @click.once="removeFriend(row.name)">Remove</button></div>
        <div class="clearfix"></div>
      </div>
    </div>

    <div class="activity-container">
      <activity-timeline :events="events" :friends="true"></activity-timeline>
    </div>
  </div>
</template>

<script>
import SnapsOption from "@/components/Page/SnapsOption";

import Head from "@/components/Page/Head";
import Heading from "@/components/Page/Heading";
import List from "@/components/Book/List";
import Back from "../modules/Back";
import Bus from "../modules/Bus";
import FindBook from "@/components/Page/FindBook";
import ActivityTimeline from "@/components/Activity/Timeline";
import ReviewChart from "@/components/Book/ReviewChart";
import ResultsTable from "@/components/Book/ResultsTable";
import NoContent from "@/components/Page/NoContent";
import Challenges from "@/components/Challenges/Challenges";
import PowerUps from "@/components/PowerUps/PowerUps";
import { mapState } from "vuex";

export default {
  name: "Page",
  components: {
    Head,
    Heading,
    SnapsOption,
    ActivityTimeline,
  },
  computed: {
    ...mapState({
      user: "user",
      books: "books",
      events: "events",
    }),
  },
  data: function () {
    return {
      friendsTable: null,
      shareLink: null,
    };
  },
  watch: {
    user(newValue, oldValue) {
      const user = newValue;
      this.shareLink =
        "https://account.pubby.co/start-friend?friend=" + user.id;
    },
  },
  mounted() {
    console.log("mounted refer", this.user, this.user.referOption);
    this.shareLink =
      "https://account.pubby.co/start-friend?friend=" + this.user.id;
  },
  async created() {
    this.friendsTable = await Back.friendsReport();
    console.log("friendsTable", this.friendsTable);
  },
  methods: {
    removeFriend(name) {
      const newFriendsTable = Back.removeFriend(name);
        newFriendsTable.then((response) => {
          this.friendsTable = response;
        });
    },
    copyLink() {
      copyToClipboard(this.shareLink);

      const command = isMacintosh() ? "Command+V" : "Ctrl+V";

      let message = "";

      message =
        "Your link is copied! You can paste it (" +
        command +
        ") anywhere to share it (Email, text, social media message, etc.)!";

      this.$toasted.show(message, {
        icon: "link",
        position: "bottom-center",
        duration: 6000,
      });
    },
  },
};

function copyToClipboard(text) {
  if (window.clipboardData && window.clipboardData.setData) {
    // IE specific code path to prevent textarea being shown while dialog is visible.
    return clipboardData.setData("Text", text);
  } else if (
    document.queryCommandSupported &&
    document.queryCommandSupported("copy")
  ) {
    var textarea = document.createElement("textarea");
    textarea.textContent = text;
    textarea.style.position = "fixed"; // Prevent scrolling to bottom of page in MS Edge.
    document.body.appendChild(textarea);
    textarea.select();
    try {
      return document.execCommand("copy"); // Security exception may be thrown by some browsers.
    } catch (ex) {
      console.warn("Copy to clipboard failed.", ex);
      return false;
    } finally {
      document.body.removeChild(textarea);
    }
  }
}

function isMacintosh() {
  return navigator.platform.indexOf("Mac") > -1;
}
</script>

<style scoped lang="scss">
.pub-head {
  max-width: 560px;
  margin: 0 auto;
  padding-top: 4px;
}
.pub-head-icon {
  float: left;
  width: 100px;
}
.pub-head-text {
}
.pub-head-icon-img {
  width: 68px;
  margin: 46px 0 0 0;
}

.friends-page {
  font-family: $font-family;
  padding-bottom: 140px;
}
.friends-heading {
  padding: 30px 0 2px 0;
  text-align: left;
  font-size: 26pt;
  font-weight: 600;
  font-family: $font-family;
  text-align: center;
}
.friends-intro {
  width: 600px;
  margin: 0 auto;
  padding: 20px 0 0 0;
  font-size: 14.5pt;
  font-family: $font-family;
}
.friends-subheading {
  padding-top: 20px;
  font-size: 19pt;
  font-weight: 700;
  font-family: $font-family;
  text-align: center;
}
.friends-how-item {
  width: 600px;
  margin: 0 auto;
  padding: 20px 0 0 0;
  font-size: 14.5pt;
  font-family: $font-family;
}
.friends-img-container {
  text-align: center;
}
.friends-img {
  width: 230px;
  margin: 4px auto;
  text-align: center;
}

.friends-table {
  width: 760px;
  margin: 20px auto;

  .friends-row {
    border-bottom: 1px solid #eee;
    padding: 8px 12px;
  }

  .friends-hcell {
    width: 170px;
    float: left;
    font-size: 12pt;
    //font-weight: 700;
  }
  .friends-cell {
    width: 170px;
    float: left;
    font-size: 13pt;
    padding-top: 8px;
  }
  .friends-cell-remove {
    width: 170px;
    float: left;
  }
  .friends-cell-name {
    width: 200px;
    //font-weight: 700;
  }
}

.activity-container {
  width: 620px;
  margin: 20px auto;
}

.pub-subheading {
  text-align: left;
  font-size: 14.5pt;
  font-weight: 500;
  font-family: $font-family;
  text-align: center;
}

.pub-options {
  max-width: 1080px;
  margin: 20px auto;
  padding: 0 20px;
  //border-top: 2px solid #eee;
  font-family: $font-family;
}

.content-container {
  max-width: 1000px !important;
  margin-left: 4px;
  border-bottom: 0;
}

.content-challenges {
  max-width: 100% !important;
  border-top: 2px solid #eee;
  //padding-top: 20px;
}
.column-challenges {
  max-width: 710px;
}

.section-divider {
  width: 100%;
  height: 40px;
}

.add-book {
  display: block;
  margin: 0 auto;
  width: 200px;
  height: 52px;
  border-radius: 52px;
  border: 1px solid #ddd;
}
.add-icon {
  float: left;
  width: 32px;
  margin: 0px 0 0 32px;
  font-size: 26pt;
  text-align: center;
  color: #2196f3;
}
.add-label {
  float: left;
  width: 120px;
  margin: 10px 0 0 6px;
  font-size: 15pt;
  font-weight: 600;
  color: #2196f3;
  font-family: "Source Sans Pro";
}

.add-book:hover {
  box-shadow: 0 0 0.3rem rgba(0, 0, 0, 0.3);
  cursor: pointer;
  transition: scale(1.05);
}
.grow {
  transition: all 0.1s ease-in-out;
}
.grow:hover {
  transform: scale(1.03);
}

.activity-col {
  padding-left: 2px;
  max-width: 710px;
  margin: 20px 0;
}

.pub-jobs {
  max-width: 700px;
  margin: 40px auto;
}
.pub-jobs-heading {
  padding: 0.5em 0;
  font-size: 17pt;
  font-weight: 600;
  font-family: $font-family;
  text-align: left;
}

.pub-meet {
  padding: 20px;
  padding-top: 8px;
}

.pub-meet-headshot-col {
  float: left;
  width: 33%;
  text-align: right;
}
.pub-meet-content-col {
  float: left;
  width: 67%;
  font-family: $font-family;
}

.pub-meet-headshot-img {
  border-radius: 100px;
  width: 120px;
  margin-right: 40px;
}
.pub-meet-heading {
  padding: 0.5em 0;
  font-size: 17pt;
  font-weight: 600;
}
.pub-meet-body {
  font-size: 12pt;
  max-width: 580px;
}
.pub-meet-heading-2 {
  padding: 0.5em 0;
  font-size: 14pt;
  font-weight: 700;
}
.pub-meet-testimonial {
  font-size: 12pt;
  max-width: 580px;
  padding-left: 40px;
}
.pub-meet-byline {
  text-align: right;
  font-size: 12pt;
  max-width: 580px;
  font-style: italic;
  padding-top: 0.2em;
  padding-bottom: 1em;
}

.refer-link {
  display: flex;
  justify-content: center;
  padding: 20px 0 40px 0;
}
.refer-label {
  color: $color-blue;
  font-size: 15pt;
  font-weight: 700;
  padding: 0.55em 0.75em;
}
.refer-url {
  width: 520px;
  border: 2px solid darken(#e3f2fd, 10%);
  border-radius: 4px;
  padding: 0.5em 1em;
  font-size: 14pt;
  color: darken(#e3f2fd, 50%);
  background: lighten(#e3f2fd, 4%);
  outline: none;
}
.refer-url-more {
  width: 500px;
  padding: 6px 0 6px 20px;
  font-size: 12pt;
  color: #111;
}
.refer-copy-icon {
  font-size: 17pt;
  padding: 2.85em 0.3em 0 1em;
}
.refer-copy-tool {
  font-size: 15pt;
  padding: 3.1em 0em 0em 0em;
}
.refer-copy-icon:hover,
.refer-copy-tool:hover {
  cursor: pointer;
  opacity: 0.7;
}

@media (max-width: 1024px) {
  .add-book-container {
    padding-bottom: 20px;
  }

  .activity-col {
    padding-left: 0;
  }
}
</style>